// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--Zoq1b";
export var root = "Layout-module--root--GW-Vk";
export var withBreadcrumbs = "Layout-module--withBreadcrumbs--nCSPV";